<template>
    <!-- #region meats -->
    <template v-if="campaignOptions.meats != null">
        <div class="border-b border-a-brown-d7c7b8">
            <RadioImgGroup :label="lbl.productDetail.sections.meats" v-model="optionStates.meats"
                :items="campaignOptions.meats" :textKey="localeCode == 1033 ? 'name_en' : 'name'"></RadioImgGroup>
        </div>
    </template>
    <!-- #endregion meats -->

    <!-- #region others -->
    <template v-if="campaignOptions.others.length > 0">
        <template v-for="(other, idx) of campaignOptions.others" :key="`campaign-options-other-${idx}`">
            <div class="border-b border-a-brown-d7c7b8">
                <RadioGroup v-if="other.type == 'radio'"
                    :label="localeCode == 1033 ? other.header_en : other.header" :items="other.data"
                    v-model="optionStates.others[idx].data" textKey="name" valueKey="id"></RadioGroup>

                <CheckboxGroup v-else-if="other.type == 'checkbox'"
                    :label="localeCode == 1033 ? other.header_en : other.header" :items="other.data"
                    v-model="optionStates.others[idx].data" textKey="name" valueKey="id"
                    @update:unselectedList="onUnselectedOthers($event, idx)"></CheckboxGroup>
            </div>
        </template>
    </template>
    <!-- #endregion others -->

    <!-- #region addOn -->
    <template v-if="campaignOptions.addOn.length > 0 && (campaignOptions?.addOns == null || campaignOptions?.addOns.length == 0)">
        <div class="border-b border-a-brown-d7c7b8">
            <Collapsible :label="lbl.productDetail.sections.addOn">
                <QuantityControlGroup v-model="optionStates.addOn" :items="campaignOptions.addOn"
                    @onReady="onAddOnReady">
                </QuantityControlGroup>
            </Collapsible>
        </div>
    </template>
    <!-- #endregion addOn -->

    <!-- #region ingredients -->
    <template v-if="campaignOptions.ingredients != null && campaignOptions.ingredients.length > 0 && (campaignOptions.multiIngredients == null || campaignOptions.multiIngredients.length <= 1 )">
        <div class="border-b border-a-brown-d7c7b8">
            <template v-if="aLaCarteMode">
                <CheckboxGroup
                    :label="lbl.productDetail.sections.ingredients"
                    v-model="optionStates.ingredients[0].list"
                    :items="campaignOptions.ingredients" valueKey="id"
                    :dataSelected="setIngredients()"
                    :textKey="localeCode == 1033 ? 'name_en' : 'name'"
                    :isOptional="true" defaultAll
                    :excepList="unlistIngredients"
                    @update:unselectedList="onUnselectedIngredients($event)">
                </CheckboxGroup>
            </template>
            <template v-else>
                <Collapsible :label="lbl.productDetail.sections.ingredients">
                    <CheckboxGroup
                        v-model="optionStates.ingredients[0].list"
                        :items="campaignOptions.ingredients"
                        :dataSelected="setIngredients()"
                        :parentIsCollapsible="true" defaultAll
                        :excepList="unlistIngredients" valueKey="id"
                        :textKey="localeCode == 1033 ? 'name_en' : 'name'"
                        @update:unselectedList="onUnselectedIngredients($event)">
                    </CheckboxGroup>
                </Collapsible>
            </template>
        </div>
    </template>
    <template v-if="campaignOptions.multiIngredients != null && campaignOptions.multiIngredients.length == 1">
        <div
            class="border-b border-a-brown-d7c7b8"
            v-for="(singleIngredients, idx) in campaignOptions.multiIngredients"
            :key="idx" v-show="tabIndexAddOns == idx"
        >
            <template v-for="(ingredient, idxIngredient) in singleIngredients" :key="idxIngredient">
                <Collapsible :label="lbl.productDetail.sections.ingredients">
                    <CheckboxGroup
                        v-model="optionStates.multiIngredients[idx].items"
                        :items="ingredient"
                        :dataSelected="setRemarks(idx)"
                        :parentIsCollapsible="true" defaultAll
                        :excepList="unlistMultiIngredients" valueKey="id"
                        :textKey="localeCode == 1033 ? 'name_en' : 'name'"
                        @update:unselectedList="onUnselectedIngredients($event)">
                    </CheckboxGroup>
                </Collapsible>
            </template>
        </div>
    </template>
    <!-- #endregion ingredients -->

    <!-- #region addOns -->
    <template v-if="campaignOptions.addOns != null && campaignOptions.addOns.length > 0 && campaignOptions.isShowAddOnTab">
        <div class="bg-a-egg-fff5e7 pt-6 -mx-4 border-b border-t border-a-brown-d7c7b8">
            <div class="mx-4">
                <HeadSlider :headList="campaignOptions.addOns" @clickTab="tabAddOns($event)"></HeadSlider>
                <div class="border-b border-a-brown-d7c7b8">
                    <div v-for="(addOn, idx) in campaignOptions.addOns" :key="idx" v-show="tabIndexAddOns == idx">
                        <Collapsible :label="lbl.productDetail.sections.addOn" v-if="addOn.list && addOn.list.length > 0">
                            <QuantityControlGroup
                                v-if="addOn.list"
                                v-model="optionStates.addOns[idx]"
                                :items="addOn.list"
                                @onReady="onAddOnsReady">
                            </QuantityControlGroup>
                        </Collapsible>
                    </div>
                </div>
                <template v-if="campaignOptions.multiIngredients != null && campaignOptions.multiIngredients[tabIndexAddOns].items.length > 0">
                    <div
                        v-for="(singleIngredients, idxSingleIngredients) in campaignOptions.multiIngredients"
                        :key="idxSingleIngredients" v-show="tabIndexAddOns == idxSingleIngredients"
                    >
                        <template v-for="(ingredient, idxIngredient) in singleIngredients" :key="idxIngredient">
                            <Collapsible :label="lbl.productDetail.sections.ingredients">
                                <CheckboxGroup
                                    v-model="optionStates.multiIngredients[idxSingleIngredients].items"
                                    :items="ingredient"
                                    :dataSelected="setRemarks(idxSingleIngredients)"
                                    :parentIsCollapsible="true" defaultAll
                                    :excepList="unlistMultiIngredients" valueKey="id"
                                    :textKey="localeCode == 1033 ? 'name_en' : 'name'"
                                    @update:unselectedList="onUnselectedMultiIngredients($event, idxSingleIngredients)">
                                </CheckboxGroup>
                            </Collapsible>
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </template>
    <!-- #endregion addOns -->

    <!-- #region appetizers -->
    <template v-if="campaignOptions.appetizers != null && campaignOptions.appetizers?.length > 0">
        <template v-for="(appetizer, idx) in campaignOptions.appetizers" :key="`campaign-options-appetizers-${idx}`">
            <Collapsible class="border-b border-a-brown-d7c7b8" :label="localeCode == 1033 ? appetizer.header_en : appetizer.header">
                <CheckboxGroup
                    v-if="appetizer.maximum_item !== undefined && appetizer?.list"
                    v-model="optionStates.appetizers[idx].list"
                    class="pt-5 border-t border-a-brown-d7c7b8"
                    :items="appetizer?.list"
                    :dataSelected="setAppetizers(idx)"
                    :parentIsCollapsible="true"
                    :excepList="unlistAppetizers" valueKey="id"
                    textKey="name"
                    @update:unselectedList="onUnselectedAppetizers($event, idx)">
                </CheckboxGroup>
                <QuantityControlGroup
                    v-else-if="appetizer?.list"
                    class="pt-5 border-t border-a-brown-d7c7b8"
                    v-model="optionStates.appetizers[idx]"
                    :items="appetizer?.list"
                    @onReady="onAppetizersReady">
                </QuantityControlGroup>
            </Collapsible>
        </template>
    </template>
    <!-- #endregion appetizers -->
    <div class="flex py-4 border-b border-a-brown-d7c7b8"
        v-if="subscriptionList.length > 0">
        <div class="text-a-brown-502314 package-left">{{ lbl.subscription.buy.subscription_package }}</div>
        <div class="cursor-pointer ml-auto mr-0 package-right relative" @click="onClickSubscription()">
            <div class="text-a-red-d62300 text-right text-1-line">
                {{ optionStates.subScription && optionStates.subScription.SubscriptionDetailName ? optionStates.subScription.SubscriptionDetailName : 'See more subscription' }}
            </div>
            <img class="absolute bottom-1 right-0 ml-1 mr-0" src="@/assets/icon/ic-arrow-right-brown.svg" />
        </div>
    </div>
    <template v-if="initQty">
        <QuantityControl v-model="optionStates.quantity" :controller="qtyController" large textBold></QuantityControl>
    </template>
    <!-- <QuantityControl v-if="initQty" v-model="optionStates.quantity" :controller="qtyController" large textBold></QuantityControl> -->
</template>
<style lang="scss" scoped>
    .package-left {
        width: 165px;
    }

    .package-right {
        width: calc(100% - 165px);
        padding-right: 15px;
    }
</style>
<script>
// components
import { computed, inject, ref } from 'vue'
import RadioImgGroup from './components/RadioImgGroup.vue'
import RadioGroup from './components/RadioGroup.vue'
import Collapsible from '../Collapsible.vue'
import CheckboxGroup from './components/CheckboxGroup.vue'
import QuantityControl from './components/QuantityControl.vue'
import QuantityControlGroup from './components/QuantityControlGroup.vue'
import HeadSlider from '../HeadSlider.vue'

// composable
import { useQuantityControl } from './composable/useQuantityControl'
import useCampaignOptionsService from '../../composable/useCampaignOptionsService'
import usePriceService from '../../composable/usePriceService';

// model
import AddToBagModel from "../../model/AddToBagModel"

export default {
    name: 'ProductOptionsBuilder',
    props: {
        campaign: {
            type: Object
        },
        selectedOptions: {
            type: Object,
        },
        selectedQuantity: {
            type: Number,
            default: 1
        },
        subscriptionItem: {
            type: Array
        
        },
        subscriptionItemTemp: {
            type: Array
        
        }
    },
    components: {
        RadioImgGroup,
        RadioGroup,
        Collapsible,
        CheckboxGroup,
        QuantityControl,
        QuantityControlGroup,
        HeadSlider,
    },
    expose: ["getParams","getOptionLabel"],
    setup: function (props) {
        const SideMenuStore = inject("SideMenuStore")
        const { localeCode, lbl } = inject("LocaleStore")
        /**@type {import("@vue/reactivity").Ref<number>} */
        const priceState = inject("PriceState")
        const priceBeforeDiscount = inject("PriceBeforeDiscountState")
        const subscriptionSelected = inject("SubscriptionSelected")
        const { campaignOptions, optionStates, setSelectedOptions } = useCampaignOptionsService(props.campaign, props.selectedOptions, props.subscriptionItem)
        
        const tabIndexAddOns = ref(0)
        let subscriptionList = ref(props.subscriptionItem)

        const aLaCarteMode = computed(() => {
            if (campaignOptions.meats == null || campaignOptions.others.length == 0 || campaignOptions.addOn.length == 0) {
                return true
            }
            return false
        })

        let initQty = ref(false)

        // for main qty
        const qtyController = useQuantityControl({
            main: true,
            name: lbl.value.productDetail.sections.quantity
        }, props.selectedOptions.quantity, 1)

        const updateQty = function () {
            if (optionStates.subScription != null) {
                qtyController.maxQty = 1;
            } else {
                qtyController.maxQty = 99;
            }
            setTimeout(() => {
                initQty.value = true
            }, 1000);
        }

        updateQty()
        

        // use price service to calculate total net price
        usePriceService(props.campaign, campaignOptions, optionStates, priceState, priceBeforeDiscount, subscriptionSelected)

        // get add to cart params model from builder
        const getParams = function () {
            return new AddToBagModel().fromOptionsBuilder(props.campaign, campaignOptions, optionStates).getParams()
        }
        const getOptionLabel = function () {
            return new AddToBagModel().fromOptionsBuilder(props.campaign, campaignOptions, optionStates).getOptionLabel()
        }

        const onAddOnReady = function () {
            setSelectedOptions("addOn")
        }
        const onAddOnsReady = function () {
            setSelectedOptions("addOns")
        }
        const onAppetizersReady = function () {
            setSelectedOptions("appetizers")
        }

        const tabAddOns = function (data) {
            tabIndexAddOns.value = data.index
            setSelectedOptions("addOns")
        }

        const onUnselectedMultiIngredients = function (data, idx) {
            console.log("🚀 ~ file: ProductOptionsBuilder.vue:255 ~ onUnselectedMultiIngredients ~ idx:", idx)
            console.log("🚀 ~ file: ProductOptionsBuilder.vue:255 ~ onUnselectedMultiIngredients ~ data:", data)
            if(data.existsIdx == -1){
                optionStates.multiIngredients[idx].data.splice(data.existsIdx, 1)
            }else {
                optionStates.multiIngredients[idx].data.push(data.item)
                optionStates.multiIngredients[idx].data = optionStates.multiIngredients[idx].data.filter((item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id)
                );
            }
        }

        const onUnselectedAppetizers = function (data, idx) {
            if(data.existsIdx == -1){
                optionStates.appetizers[idx].data.splice(data.existsIdx, 1)
            }else {
                optionStates.appetizers[idx].data.push(data.item)
                optionStates.appetizers[idx].data = optionStates.appetizers[idx].data.filter((item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id)
                );
            }
        }

        const onUnselectedIngredients = function (data){
            if(data.existsIdx == -1){
                optionStates.ingredients[0].data.splice(data.existsIdx, 1)
            }else {
                optionStates.ingredients[0].data.push(data.item)
                optionStates.ingredients[0].data = optionStates.ingredients[0].data.filter((item, index, self) =>
                index === self.findIndex((t) => t.id === item.id)
                );
            }
        }

        const onUnselectedOthers = function (data, idx) {
            if(data.existsIdx == -1){
                optionStates.others[idx].data.splice(data.existsIdx, 1)
            }else {
                optionStates.others[idx].data.push(data.item)
                optionStates.others[idx].data = optionStates.others[idx].data.filter((item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id)
                );
            }
        }
        // set remarks from cart
        const setRemarks = function (index){
            if(props.selectedOptions.remark.remarks.length > 0){
                for(const selected of props.selectedOptions.remark.remarks){
                    if(selected.index == index){
                        return selected.items
                    }
                }
            }
            return []
        }

        // set appetizers from cart
        const setAppetizers = function (index){
            if(props.selectedOptions.remark.appetizers.length > 0){
                for(const selected of props.selectedOptions.remark.appetizers){
                    if(selected.index == index){
                        return selected.items
                    }
                }
            }
            return []
        }

        // set ingredients from cart
        const setIngredients = function () {
            if(props.selectedOptions.unlistIngredients.length > 0){
                return props.selectedOptions.unlistIngredients[0].items
            }
            return []
        }

        const onClickSubscription = function () {
            // create subscription temp for manage subscription
            let subscriptionTemp = subscriptionList.value.map((item) => {
                return {
                    ...item
                }
            })
            SideMenuStore.methods.openSubscription(subscriptionTemp, priceBeforeDiscount, 'online', (data) => {
                subscriptionList.value = data
                campaignOptions.subscriptionList = data;
                setSelectedOptions("subscription")
                
                initQty.value = false
                qtyController.qty.value = 1;

                updateQty()
            })
        }



        console.log("campaignOptions", campaignOptions)

        return {
            campaignOptions,
            optionStates,
            qtyController,
            lbl,
            localeCode,
            getParams,
            aLaCarteMode,
            onAddOnReady,
            onAddOnsReady,
            onAppetizersReady,
            getOptionLabel,
            unlistIngredients: props.selectedOptions.unlistIngredients,
            unlistAppetizers: props.selectedOptions.unlistAppetizers,
            unlistMultiIngredients: props.selectedOptions.unlistMultiIngredients,
            tabAddOns,
            tabIndexAddOns,
            onUnselectedMultiIngredients,
            onUnselectedAppetizers,
            onUnselectedIngredients,
            onUnselectedOthers,
            setRemarks,
            setAppetizers,
            setIngredients,
            onClickSubscription,
            subscriptionList,
            initQty
        }
    },
}
</script>
